import type { Idioma } from './index';

export const FUS_HORARI = 'Europe/Madrid';

const LOCALE: Record<Idioma, string> = { ca: 'ca-ES', es: 'es-ES' };

export function locale(idioma: Idioma): string {
  return LOCALE[idioma];
}

function aData(valor: string | number | Date): Date {
  return valor instanceof Date ? valor : new Date(valor);
}

export function formataData(valor: string | number | Date, idioma: Idioma): string {
  return new Intl.DateTimeFormat(LOCALE[idioma], {
    timeZone: FUS_HORARI,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(aData(valor));
}

export function formataHora(valor: string | number | Date, idioma: Idioma): string {
  return new Intl.DateTimeFormat(LOCALE[idioma], {
    timeZone: FUS_HORARI,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(aData(valor));
}

export function formataDataHora(valor: string | number | Date, idioma: Idioma): string {
  return new Intl.DateTimeFormat(LOCALE[idioma], {
    timeZone: FUS_HORARI,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(aData(valor));
}

export function formataDataLlarga(valor: string | number | Date, idioma: Idioma): string {
  return new Intl.DateTimeFormat(LOCALE[idioma], {
    timeZone: FUS_HORARI,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(aData(valor));
}

export function formataNumero(valor: number, idioma: Idioma, decimals = 0): string {
  return new Intl.NumberFormat(LOCALE[idioma], {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(valor);
}

export function formataPercentatge(valor: number, idioma: Idioma, decimals = 0): string {
  return new Intl.NumberFormat(LOCALE[idioma], {
    style: 'percent',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(valor / 100);
}

export function formataDurada(segons: number): string {
  const total = Math.max(0, Math.round(segons));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}
